<template>
  <div class="product-upgrades-header-component">
    <div class="main">
      <span class="title" v-if="config.title">{{ config.title }}</span>
      <div class="divider"></div>
      <span class="vehicle-name">{{ getActiveVehicleDisplayName() }}</span>
    </div>
    <button class="close-button" @click="$emit('close')"></button>
  </div>
</template>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.product-upgrades-header-component {
  background: $brand-color-1;
  padding: 10px 30px;
  box-shadow: $drop-shadow;

  .main {
    display: flex;
    align-items: center;
    line-height: 1.25;
    font-size: 19px;
    font-weight: 300;
    color: #fff;

    .title {
      font-size: 19px;
      font-weight: 600;
      font-style: normal;
    }

    .divider {
      width: 1px;
      height: 20px;
      background-color: #fff;
      margin: 0 15px;
    }

    .vehicle-name {
      display: inline-block;
      text-transform: lowercase;

      &::first-letter {
        text-transform: uppercase;
      }
    }
  }

  .close-button {
    background: transparent;
    position: absolute;
    right: 15px;
    top: 10px;
    width: 24px;
    height: 24px;
    opacity: 1;
    border: none;

    &:before,
    &:after {
      background: #fff;
      position: absolute;
      top: 0;
      left: 11px;
      content: " ";
      height: 24px;
      width: 2px;
    }

    &:before {
      transform: rotate(45deg);
    }

    &:after {
      transform: rotate(-45deg);
    }

    &:focus {
      outline: none;
    }
  }
}

@media (max-width: 480px) {
  .product-upgrades-header-component {
    background: #fff;
    box-shadow: none;

    .main {
      display: block;
      color: $brand-color-1;

      .title {
        display: block;
        font-size: 1.125rem;
      }

      .divider {
        display: none;
      }
    }

    .close-button {
      &:before,
      &:after {
        background: $brand-color-1;
      }
    }
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import { modalService } from "@/services";

export default {
  name: "ProductUpgradesHeader",
  props: ["config"],
  computed: {
    ...mapGetters("asset", ["getActiveVehicleDisplayName"]),
    isMobile() {
      return this.$isMobile();
    },
  },
};
</script>
